import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Col, Row} from "reactstrap";
import axios from "axios";
import VatiaCheckoutSummary from "./VatiaCheckoutSummary";
import VatiaCheckoutStep0 from "./VatiaCheckoutStep0";
import VatiaCheckoutStep1 from "./VatiaCheckoutStep1";
import VatiaCheckoutStep2 from "./VatiaCheckoutStep2";
import VatiaCheckoutStep3 from "./VatiaCheckoutStep3";
import VatiaCheckoutNavigation from "./VatiaCheckoutNavigation";
import {FormattedMessage, useIntl} from "react-intl";
import { Checkmark } from "react-checkmark";
import {Card, CardContent} from "@mui/material";
import QRCode from "react-qr-code";
import {getBackendUrl} from "./vatia-functions";

const timeframeCancelAnytime = <FormattedMessage id={"abo.new.timeframe.cancel.anytime"} defaultValue={"Jederzeit kündbar"} />;
const timeframeOneTimePayment = <FormattedMessage id={"abo.new.timeframe.onetime.payment"} defaultValue={"Einmalige Zahlung"} />;

const step1Text = <FormattedMessage id={"abo.new.navigation.step1.size"} defaultValue={'Grösse'} />;
const step2Text = <FormattedMessage id={"abo.new.navigation.step2.timeframe"} defaultValue={'Laufzeit'} />;
const step3Text = <FormattedMessage id={"abo.new.navigation.step3.delivery"} defaultValue={'Lieferadresse'} />;
const step4Text = <FormattedMessage id={"abo.new.navigation.step4.payment"} defaultValue={'Zahlung'} />;

const timeframeMonthly = <FormattedMessage id={"abo.new.timeframe.text.monthly"} defaultValue={'Monatlich'} />;

const steps = [step1Text, step2Text, step3Text, step4Text];

const sizeData = [
    {title: "6-Pack", subtitle: "Craft Beer of the Month", price: 39},
    {title: "12-Pack", subtitle: "Craft Beer of the Month", price: 60},
    {title: "24-Pack", subtitle: "Craft Beer of the Month", price: 110},
];

const timeframeData =
    {
        "6-Pack":  [
            {title: timeframeMonthly, months: 1, subtitle: timeframeCancelAnytime, text: "", price: 39, plan: "price_1Lwk7CHxVenJwvGfoZDIXKNg"},
            // {title: "1 Jahr", months: 12, subtitle: timeframeOneTimePayment, text: "gift", price: 468, plan: "price_1MZxuZHxVenJwvGf2FZonajx"},
            // {title: "6 Monate", months: 6, subtitle: timeframeOneTimePayment, text: "gift",  price: 234, plan: "price_1MZxvWHxVenJwvGfNKaw2AW5"},
        ],
        "12-Pack":  [
            {title: timeframeMonthly, months: 1, subtitle: timeframeCancelAnytime, text: "_", price: 60, plan: "price_1Lwk7NHxVenJwvGfSCe3CA6S"},
            // {title: "1 Jahr", months: 12, subtitle: timeframeOneTimePayment, text: "gift", price: 60*12, plan: "price_1MZxwTHxVenJwvGfDFeguQmL"},
            // {title: "6 Monate", months: 6, subtitle: timeframeOneTimePayment, text: "gift",  price: 60*6, plan: "price_1MZxxFHxVenJwvGf29iwcPzd"},
        ],
        "24-Pack":  [
            {title: timeframeMonthly, months: 1, subtitle: timeframeCancelAnytime, text: "_", price: 110, plan: "price_1Lwk7YHxVenJwvGff7CCBZJF"},
            // {title: "1 Jahr", months: 12, subtitle: timeframeOneTimePayment, text: "gift", price: 110*12, plan: "price_1MZxy2HxVenJwvGf8ZfcQVrG"},
            // {title: "6 Monate", months: 6, subtitle: timeframeOneTimePayment, text: "gift",  price: 110*6, plan: "price_1MZxyRHxVenJwvGf2TilQ9sJ"},
        ]
    }
;

const cards = [null, null, null];

export default function VatiaCheckout(props)
{
    const intl = useIntl()

    const [width, setWidth] = React.useState(window.innerWidth);
    React.useEffect(() => {
        const handleResizeWindow = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResizeWindow);
        return () => {
            window.removeEventListener("resize", handleResizeWindow);
        };
    }, []);
    const breakpoint = 767;

    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});

    // customer selections
    const [planTitle, setPlanTitle] = React.useState("");
    const [priceId, setPriceId] = React.useState("");
    const [priceAmount, setPriceAmount] = React.useState("");
    const [timeframeTitle, setTimeframeTitle] = React.useState(intl.locale == "en" ? "Monthly" : "Monatlich");
    const [timeframeMonths, setTimeframeMonths] = React.useState(1);

    const [selectedSize, setSelectedSize] = React.useState(null);
    const [selectedTimeframe, setSelectedTimeframe] = React.useState(0);

    // customer info
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [addressTitle, setAddressTitle] = React.useState("");
    const [line1, setLine1] = React.useState("");
    const [line2, setLine2] = React.useState("");
    const [postalcode, setPostalcode] = React.useState("");
    const [city, setCity] = React.useState("");
    const [country, setCountry] = React.useState("Schweiz");

    const [phoneIsValid, setPhoneIsValid] = React.useState(false);

    const [cardNumber, setCardNumber] = React.useState("");
    const [promoCode, setPromoCode] = React.useState("");
    const [couponInfo, setCouponInfo] = React.useState(null);
    const [couponSpinner, setCouponSpinner] = React.useState(false);
    const [promoCodeInfo, setPromoCodeInfo] = React.useState(false);

    const [isDone, setIsDone] = React.useState(false);

    // const [calculatedPrice, setCalculatedPrice] = React.useState("");

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                  // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);

        if(newActiveStep == 1)
        {
            props.toggleFooterState();
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        if(activeStep == 0)
        {
            props.toggleFooterState();
        }
    };

    // navigation clicks
    const handleStep = (step) => () => {
        setActiveStep(step);
        if(step == 0)
        {
            props.toggleFooterState();
        }
    };

    // const handleComplete = () => {
    //     const newCompleted = completed;
    //     newCompleted[activeStep] = true;
    //     setCompleted(newCompleted);
    //     handleNext();
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    //     setCompleted({});
    //
    //     if(activeStep == 0)
    //     {
    //         props.toggleFooterState();
    //     }
    // };

    const handleFirstname = (event) =>
    {
        setFirstName(event.target.value)
        setAddressTitle(event.target.value)
    }

    const handleLastname = (event) =>
    {
        setLastName(event.target.value);
    }

    const handleAddress = (event) =>
    {
        setLine1(event.target.value);
    }

    const handleAddress2 = (event) =>
    {
        setLine2(event.target.value);
    }

    const handlePlz = (event) =>
    {
        setPostalcode(event.target.value);
    }

    const handleCity = (event) =>
    {
        setCity(event.target.value);
    }

    const handleCountry = (event) =>
    {
        setCountry(event.target.value);
    }

    const handlePhone = (value, country) =>
    {
        setPhone("+"+value);
        setPhoneIsValid(value.length == 2 || value.length == country.format.replaceAll(" ","").length-1)
    }

    const handleEmail = (event) =>
    {
        setEmail(event.target.value);
    }

    const handleSizeSelection = (planTitle, price, index) =>
    {
        setSelectedSize(index);
        setPlanTitle(planTitle);
        setPriceAmount(price);
        setPriceId(timeframeData[planTitle][selectedTimeframe].plan)

        setTimeout(() => {
            // handleStep(1);
            // handleComplete();
            // handleNext();
        }, 800);
    }

    const handleTimeframeUpdate = (index, timeframeTitle, timeframeMonths, price) =>
    {
        setSelectedTimeframe(index)
        setTimeframeTitle(timeframeTitle)
        setTimeframeMonths(timeframeMonths)
        setPriceAmount(price)
        setPriceId(timeframeData[planTitle][index].plan)

        if(timeframeTitle != "Monatlich")
        {
            setCouponInfo(null)
            setPromoCodeInfo("")
        }

        setTimeout(() => {
            // handleNext();
        }, 800);
    }

    const handlePromoCode = (event) => {
        setPromoCode(event.target.value);
    };

    const handlePromoCodeSubmit = async () =>
    {
        setCouponSpinner(true);

        // Make a request for a user with a given ID
        var couponInfo = await axios.post(getBackendUrl()+'vatia/coupon-info/'+'brauwolf', {
            data: {
                promocode: promoCode,
            }
        })
        .then(function (response) {
            // handle success
            return response.data;
        })
        .catch(function (error) {
            // handle error
            // console.log(error);
        })

        if(couponInfo != null && couponInfo.percentOff != null)
        {
            setCouponInfo(couponInfo)
            setPromoCodeInfo("");
        }
        else
        {
            setCouponInfo(null)
            setPromoCode(null)
            setPromoCodeInfo("Ungültiger Promocode")
        }

        setCouponSpinner(false);
    }

    const removePromoCode = () =>
    {
        setCouponInfo(null)
    }

    // md
    let leftSideMd = activeStep > 0 ? 0 : 0;
    let rightSideMd = activeStep > 0 ? 0 : 0;
    let wrapperWidthMd = activeStep > 0 ? 12 : 12;

    // large
    let leftSideLg = activeStep > 0 ? 2 : 0;
    let rightSideLg = activeStep > 0 ? 1 : 0;
    let wrapperWidthLg = activeStep > 0 ? 6 : 12;

    // xl
    let leftSideXl = activeStep > 0 ? 5 : 0;
    let rightSideXl = activeStep > 0 ? 4 : 0;
    let wrapperWidthXl = activeStep > 0 ? 6 : 12;

    let summaryWidth = activeStep > 0 ? 3 : 12;
    let mainWidth = activeStep > 0 ? 12 : 12;

    let mainContent = <Box className={"padding-bottom-3x padding-top-2x"} sx={{ width: '100%', maxWidth:activeStep > 0 ? 900 : 99999999}}>
        <div style={{maxWidth: 900, marginLeft:"auto", marginRight:"auto"}}>
            <Row style={{paddingLeft:1==0 ? 190:0}}>
                <Col xl={mainWidth} lg={mainWidth} md={mainWidth} sm={12} xs={12}>
                    <div style={{paddingLeft:activeStep > 0 ? 20: 0, paddingRight:activeStep > 0 ? 20: 0}}>
                        <React.Fragment>
                            <VatiaCheckoutNavigation width={width} breakpoint={breakpoint} activeStep={activeStep} completed={completed} steps={steps} handleStep={handleStep}/>
                            <Row>
                                <Typography sx={{ mt: 2, mb: 1, py: 1 }} style={{marginTop:0}}>
                                    {
                                        activeStep === 0 ? <VatiaCheckoutStep0 sizeData={sizeData} selectedSize={selectedSize} handleSizeSelection={handleSizeSelection}
                                                                               cards={cards} handleNext={handleNext} lang={props.lang}/> :
                                            activeStep === 1 ? <VatiaCheckoutStep1 width={width} breakpoint={breakpoint} handleNext={handleNext} handleBack={handleBack}
                                                                                   planTitle={planTitle} timeframeData={timeframeData}
                                                                                   handleTimeframeUpdate={handleTimeframeUpdate} selectedTimeframe={selectedTimeframe}
                                                                                    cards={cards} lang={props.lang}/> :
                                                activeStep === 2 ? <VatiaCheckoutStep2 width={width} breakpoint={breakpoint} handleNext={handleNext} handleBack={handleBack}
                                                                                       email={email} handleEmail={handleEmail}
                                                                                       firstName={firstName} handleFirstname={handleFirstname}
                                                                                       lastName={lastName} handleLastname={handleLastname}
                                                                                       line1={line1} handleAddress={handleAddress}
                                                                                       line2={line2} handleAddress2={handleAddress2}
                                                                                       postalcode={postalcode} handlePlz={handlePlz}
                                                                                       city={city} handleCity={handleCity}
                                                                                       country={country} handleCountry={handleCountry}
                                                                                       phone={phone} handlePhone={handlePhone} phoneIsValid={phoneIsValid} lang={props.lang}/> :
                                                    activeStep === 3 ? <VatiaCheckoutStep3 width={width} breakpoint={breakpoint} handleBack={handleBack} handleStep={handleStep} setIsDone={setIsDone}
                                                                                           cardNumber={cardNumber} priceId={priceId} priceAmount={priceAmount} couponInfo={couponInfo}
                                                                                           planTitle={planTitle} timeframeTitle={timeframeTitle} timeframeMonths={timeframeMonths}
                                                                                           firstName={firstName} lastName={lastName} line1={line1} line2={line2} postalcode={postalcode}
                                                                                           city={city} country={country} email={email} phone={phone} lang={props.lang}/> : null
                                    }
                                </Typography>
                            </Row>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button
                                    color="inherit"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    sx={{ mr: 1 }}
                                >
                                    {/*Back*/}
                                </Button>
                                <Box sx={{ flex: '1 1 auto' }} />
                            </Box>
                        </React.Fragment>
                    </div>
                </Col>
            </Row>
        </div>
    </Box>

    let vatiaApp =  1==0 ? <Card variant="outlined"
                                                   sx={{
                                                       // maxWidth: 400,
                                                       width: '100%',
                                                       maxWidth:570,
                                                       minHeight: 100,
                                                       display: "inline-block",
                                                       marginRight: 1,
                                                       cursor: "pointer",
                                                       fontWeight: 450,
                                                       // borderColor: index == props.selectedTimeframe ? "green" : props.cards[index]
                                                   }}
    >
        <CardContent style={{paddingTop:30}}>
            <Row>
                <Col xl={6}>   <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: 150, width: "100%" }}
                    value={"https://deeplink.to.iphone.vatia.io.app"}
                    viewBox={`0 0 256 256`}
                /></Col>
                <Col xl={6} style={{paddingTop:10}}>
                    <p style={{}}><span style={{}}>Manage your subscription easily</span><br/>with the vatia app</p>
                </Col>
            </Row>
        </CardContent>
    </Card> : null

    return (
        isDone ? timeframeTitle == "Monatlich" ? <Row style={{backgroundColor:"#f5f5f5"}}>
                <Col xl={12} lg={12} md={12} sm={12} xs={12} style={{backgroundColor: activeStep > 0 ? "white" : "#fff",
                    height: "100vh"}}>
                    <div className="padding-top-2x text-center" style={{textAlign:"center"}}>
                        <div style={{maxWidth:570, margin:"auto"}}>
                            <h1><FormattedMessage id={ 'abo.title' } defaultMessage={ 'Dr. Brauwolf Abo' }/></h1>
                            <Checkmark size={96} /><br/>
                            <p><FormattedMessage id={ 'abo.success' } defaultMessage={ 'Du wurdest erfolgreich abonniert! Die erste Lieferung kommt Anfang nächsten Monats. Deine Kreditkarte wird von nun an regelmässig belastet solange das Abo aktiv ist.' }/><br/><br/>
                                <FormattedMessage id={ 'abo.stop' } defaultMessage={ 'Schreibe uns ein Mail an info@drbrauwolf.ch oder benutze den Login, wenn du das Abo ändern oder künden möchtest.'}/></p>
                        </div>
                    </div>
                    {vatiaApp}
                </Col>
        </Row> : <Row style={{backgroundColor:"#f5f5f5"}}>
                <Col xl={12} lg={12} md={12} sm={12} xs={12} style={{backgroundColor: activeStep > 0 ? "white" : "#fff",
                    height: "100vh"}}>
                    <div className="padding-top-2x text-center" style={{textAlign:"center"}}>
                        <div style={{maxWidth:570, margin:"auto"}}>
                            <h1><FormattedMessage id={ 'abo.title' } defaultMessage={ 'Dr. Brauwolf Abo' }/></h1>
                            <Checkmark size={96} /><br/>
                            <p><FormattedMessage id={ 'abo.success2' } defaultMessage={ 'Du wurdest erfolgreich abonniert! Die erste Lieferung kommt Anfang nächsten Monats. Das Abo dauert bis zum Ende des gewählten Zeitraums und wird dann automatisch beendet.' }/></p>
                        </div>
                    </div>
                    {vatiaApp}
                </Col>
            </Row> :
        <Row style={{backgroundColor:1==1 ? "#f5f5f5" : "yellow", padding: 0, margin: 0}}>
            {activeStep > 0 ? <Col xl={leftSideXl} lg={leftSideLg} md={leftSideMd} sm={0} xs={0} style={{padding:0}} className={"hidden-md hidden-sm hidden-xs"}>
                <div style={{backgroundColor: 1==1 ?"#fff":"red", width:"100%", height: "100vh", display:"inline-block"}}></div>
            </Col> : null}
            <Col xl={wrapperWidthXl} lg={wrapperWidthLg} md={wrapperWidthMd} sm={12} xs={12}
                 style={{backgroundColor: activeStep > 0 ? "white" : "#f5f5f5", height: "100vh"}}>
                {mainContent}
            </Col>
            {activeStep > 0 ? <Col xl={summaryWidth} lg={summaryWidth} md={summaryWidth} sm={12} xs={12} style={{
                marginTop: 0,
                borderLeft:"1px solid #e2e2e2",
                backgroundColor:"#f5f5f5",
                paddingTop: 78,
                height: "100vh",
                maxWidth:400
            }} className={"hidden-md hidden-sm hidden-xs"}>
                <VatiaCheckoutSummary planTitle={planTitle} timeframeTitle={timeframeTitle} timeframeMonths={timeframeMonths} couponInfo={couponInfo}
                                      removePromoCode={removePromoCode} handlePromoCode={handlePromoCode} promoCode={promoCode}
                                      handlePromoCodeSubmit={handlePromoCodeSubmit} couponSpinner={couponSpinner}
                                      priceAmount={priceAmount} promoCodeInfo={promoCodeInfo}
                                      firstName={firstName} lastName={lastName}
                                      line1={line1} line2={line2} postalcode={postalcode}
                                      city={city} country={country} lang={props.lang} />
            </Col> : null}
            {activeStep > 0 ? <Col xl={rightSideXl} lg={rightSideLg} md={rightSideMd} sm={0} xs={0} style={{padding:0}} className={"hidden-md hidden-sm hidden-xs"}>
                <div style={{backgroundColor: 1==1 ? "#f5f5f5" : "green", width:"100%", height: "100vh", display:"inline-block"}}></div>
            </Col> : null}
        </Row>
    );
}